<template>
  <b-container fluid>
    <h1>Equipment</h1>
    <b-form-group label="Filters">
      <b-form-radio-group
        id="list-filters"
        name="filters"
        :options="filters"
        v-model="selectedFilter"
      ></b-form-radio-group>
    </b-form-group>
    <b-form-input v-model="searchTeam" placeholder="Search Team"></b-form-input>
    <b-table
      :fields="fields"
      head-variant="dark"
      :items="items"
      small
      sort-by="team"
      sort-icon-left
    >
      <template v-slot:cell(action)="data">
        <b-button variant="primary" size="sm" @click="edit(data.item)">Edit</b-button>
      </template>
    </b-table>
    <b-modal title="Equipment" v-model="showModal">
      <div v-if="selectedAthlete">
        <b-form>
          <div class="d-flex align-items-center pb-3">
            <b-avatar class="mr-3"/>
            <div>
              {{ selectedAthlete.first_name }} {{ selectedAthlete.last_name }}<br>
              {{ selectedAthlete.team }}<br>
              <span class="text-capitalize">{{ selectedAthlete.weight_class.name }}</span>
            </div>
          </div>
          <b-form-group
            id="gloves-select-group"
            label="Gloves"
            label-for="gloves-select"
          >
            <b-form-select
              id="gloves-select"
              :options="sizes"
              v-model="selectedAthlete.gloves"
            ></b-form-select>
          </b-form-group>
          <b-form-group
            id="shinguards-select-group"
            label="Shinguards"
            label-for="shinguards-select"
          >
            <b-form-select
              id="shinguards-select"
              :options="sizes"
              v-model="selectedAthlete.shinguards"
            ></b-form-select>
          </b-form-group>
          <b-form-group
            id="deposit-group"
            label="Deposit"
            label-for="deposit-select"
          >
            <b-form-select
              id="deposit-select"
              :options="depositOptions"
              v-model="selectedAthlete.equipmentDeposit"
            ></b-form-select>
          </b-form-group>
        </b-form>
        <b-button v-if="hasEquipment" @click="returnEquipment">Return all</b-button>
      </div>
      <template v-slot:modal-footer>
        <b-button @click="showModal=false" variant="secondary">Discard</b-button>
        <b-button @click="showModal=false" variant="primary">Save</b-button>
      </template>
    </b-modal>
  </b-container>
</template>

<script>
export default {
  name: 'Equipment',
  data() {
    return {
      depositOptions: [
        'Personalausweis', 'Reisepass', 'Versichertenkarte', 'Führerschein',
        { value: null, text: '' },
      ],
      fields: [
        { key: 'team', sortable: true },
        { key: 'first_name', sortable: true },
        { key: 'last_name', sortable: true },
        { key: 'gloves' },
        { key: 'shinguards' },
        { key: 'equipmentDeposit', label: 'Deposit' },
        { key: 'action' },
      ],
      filters: [
        { text: 'All', value: null },
        { text: 'No equipment', value: false },
        { text: 'With equipment', value: true },
      ],
      searchTeam: '',
      selectedFilter: null,
      selectedAthlete: null,
      sizes: ['', 'XS', 'S', 'M', 'L', 'XL'],
      showModal: false,
    };
  },
  methods: {
    edit(athlete) {
      this.selectedAthlete = athlete;
      this.showModal = true;
    },
    change(item, key) {
      this.$store.commit('setValue', {
        id: item.id,
        key,
        value: item.gloves,
      });
    },
    returnEquipment() {
      this.selectedAthlete.gloves = '';
      this.selectedAthlete.shinguards = '';
      this.selectedAthlete.equipmentDeposit = '';
    },
  },
  computed: {
    hasEquipment() {
      return this.selectedAthlete.gloves
        || this.selectedAthlete.shinguards
        || this.selectedAthlete.equipmentDeposit;
    },
    items() {
      let athletes = this.$store.getters.getAthletes;
      if (this.searchTeam !== '') {
        athletes = athletes.filter((a) => a.team.toLowerCase()
          .includes(this.searchTeam.toLowerCase()));
      }
      if (this.selectedFilter) {
        return athletes.filter((a) => a.gloves || a.shinguards || a.equipmentDeposit);
      }
      if (this.selectedFilter === false) {
        return athletes.filter((a) => !a.gloves && !a.shinguards && !a.equipmentDeposit);
      }
      return athletes;
    },
  },
};
</script>
